module.exports = __webpack_public_path__ + "static/img/mvas3.ad2deba1.png";